<template>
  <v-app-bar flat fixed dark class="home-header px-0" color="primary">
    <template v-if="!$vuetify.breakpoint.smAndDown">
      <router-link to="/" link class="mt-2">
        <v-img
          :src="require('@/assets/' + logoAsset)"
          max-height="120"
          max-width="120"
          class="mt-12 px-2"
          contain
        ></v-img>
      </router-link>
      <template v-for="(link, idx) in links">
        <template v-if="link.items">
          <v-menu offset-y :key="idx" class="mx-2">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text depressed>
                <span class="header-font">
                  <b>
                    {{ link.title }}
                    <v-icon>{{ icons.menuDown }}</v-icon>
                  </b>
                </span>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                class="pointer"
                v-for="(item, index) in link.items"
                :key="idx + '-' + index"
                :to="item.path"
              >
                <v-list-item-title class="tiny-font">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-else>
          <template v-if="link.title == 'Agendar'">
            <v-btn
              :key="idx"
              :to="{ path: link.path }"
              depressed
              color="secondary"
              class="mx-2"
              active-class="highlighted"
            >
              <span class="header-font">
                <b>{{ link.title }}</b>
              </span>
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              :key="idx"
              :to="{ path: link.path }"
              depressed
              text
              class="mx-2"
              active-class="highlighted"
            >
              <span class="header-font">
                <b>{{ link.title }}</b>
              </span>
            </v-btn>
          </template>
        </template>
      </template>
      <v-spacer></v-spacer>
      <v-btn
        :to="{ path: '/contatoEmpresa' }"
        depressed
        text
        active-class="highlighted"
      >
        <span class="header-font">
          <b>Para sua Empresa</b>
        </span>
      </v-btn>
      <v-btn :to="{ path: '/login' }" depressed text active-class="highlighted">
        <span class="header-font">
          <b>Entrar/Cadastrar</b>
        </span>
      </v-btn>
    </template>
  </v-app-bar>
</template>
<script>
import { mdiMenuDown } from '@mdi/js'
export default {
  name: 'HomeHeader',
  data: () => ({
    icons: {
      menuDown: mdiMenuDown
    },
    links: [
      { title: 'Vantagens', path: '/vantagens' },
      { title: 'Serviços', path: '/saibamais' },
      { title: 'Sobre Nós', path: '/sobre' },
      { title: 'Perguntas Frequentes', path: '/faq' },
      { title: 'Contato', path: '/contato' }
    ]
  }),
  methods: {},
  computed: {
    logoAsset() {
      return process.env.VUE_APP_INSTA_LOGO
    }
  },
  mounted() {}
}
</script>

<style scoped>
.highlighted span {
  font-size: 14px;
  font-weight: bold;
}

.v-application a {
  text-decoration: none;
  color: unset;
}

.home-header {
  z-index: 99;
}
</style>
